module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agreement_txt":"I hereby acknowledge that I have read and understood the information provided above."},"si":{"agreement_txt":"ඉහත සපයා ඇති තොරතුරු මා විසින් කියවා තේරුම් ගෙන ඇති බව මෙයින් ප්‍රකාශ කරමි."},"ta":{"agreement_txt":"மேலே கொடுக்கப்பட்டுள்ள தகவல்களை நான் வாசித்துப் புரிந்துகொண்டேன் என்பதை இத்தால் அறியத் தருகின்றேன்."}}')
  delete Component.options._Ctor
}
